import type { AuthProviderProps } from 'react-oidc-context';
import { getRuntimeConfig } from '@/runtimeConfig';

// Must be called after loadRuntimeConfig() resolves — never at module import time.
export function buildOidcConfig(): AuthProviderProps {
  const cfg = getRuntimeConfig();
  const appUrl = window.location.origin;

  return {
    authority: `${cfg.keycloakUrl}/realms/${cfg.keycloakRealm}`,
    client_id: cfg.keycloakClientId,
    redirect_uri: `${appUrl}/auth/callback`,
    post_logout_redirect_uri: appUrl,
    response_type: 'code',
    scope: 'openid profile email',
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: () => {
      window.location.replace('/');
    },
  };
}

export function oidcStorageKey(): string {
  const cfg = getRuntimeConfig();
  return `oidc.user:${cfg.keycloakUrl}/realms/${cfg.keycloakRealm}:${cfg.keycloakClientId}`;
}

export function readAccessToken(): string | null {
  try {
    const raw = sessionStorage.getItem(oidcStorageKey());
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as { access_token?: unknown };
    return typeof parsed.access_token === 'string' ? parsed.access_token : null;
  } catch {
    return null;
  }
}
